var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import * as utils from '../../utils';
import { Size } from './button';
var modifiers = (_a = {},
    _a[Size.small] = { size: 36 },
    _a[Size.medium] = { size: 44 },
    _a[Size.large] = { size: 52 },
    _a[Size.wide] = { size: 64 },
    _a);
var IconSvgStyles = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  path,\n  circle {\n    fill: ", ";\n  }\n"], ["\n  path,\n  circle {\n    fill: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
});
var IconSvg;
var IconButtonSecondary = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n  background-color: transparent;\n  color: ", ";\n  cursor: ", ";\n  border-radius: 3px;\n  border: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 6px;\n\n  &:hover {\n    background-color: ", ";\n    ", " {\n      ", "\n    }\n  }\n\n  &:focus,\n  &:focus-visible {\n    background-color: ", ";\n    position: relative;\n    outline: none;\n    ", " {\n      ", "\n    }\n  }\n\n  &:focus-visible:after {\n    position: absolute;\n    width: calc(100% + 4px);\n    height: calc(100% + 4px);\n    transform: translate(-50%, -50%);\n    border: 2px solid ", ";\n    border-radius: 3px;\n    top: 50%;\n    left: 50%;\n    content: '';\n    ", " {\n      ", "\n    }\n  }\n"], ["\n  width: ", "px;\n  height: ", "px;\n  background-color: transparent;\n  color: ", ";\n  cursor: ", ";\n  border-radius: 3px;\n  border: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 6px;\n\n  &:hover {\n    background-color: ",
    ";\n    ", " {\n      ", "\n    }\n  }\n\n  &:focus,\n  &:focus-visible {\n    background-color: ",
    ";\n    position: relative;\n    outline: none;\n    ", " {\n      ", "\n    }\n  }\n\n  &:focus-visible:after {\n    position: absolute;\n    width: calc(100% + 4px);\n    height: calc(100% + 4px);\n    transform: translate(-50%, -50%);\n    border: 2px solid ", ";\n    border-radius: 3px;\n    top: 50%;\n    left: 50%;\n    content: '';\n    ", " {\n      ", "\n    }\n  }\n"])), function (_a) {
    var size = _a.size;
    return size && modifiers[size].size;
}, function (_a) {
    var size = _a.size;
    return size && modifiers[size].size;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral1;
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'default' : 'pointer');
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return !disabled && utils.hexToRGBA(theme.colors.neutral7, theme.alpha.light);
}, IconSvg, IconSvgStyles, function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return !disabled && utils.hexToRGBA(theme.colors.neutral7, theme.alpha.light);
}, IconSvg, IconSvgStyles, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return !disabled && theme.colors.neutral7;
}, IconSvg, IconSvgStyles);
IconButtonSecondary.defaultProps = {
    disabled: false,
    size: Size.small,
};
var IconSecondary = function (_a) {
    var disabled = _a.disabled, size = _a.size, icon = _a.icon, onClick = _a.onClick, rest = __rest(_a, ["disabled", "size", "icon", "onClick"]);
    var IconSvg = styled(icon)(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
    return (_jsx(IconButtonSecondary, __assign({ disabled: disabled, size: size, onClick: onClick }, { children: _jsx(IconSvg, __assign({}, rest), void 0) }), void 0));
};
export default IconSecondary;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=iconSecondary.js.map